    function loadTocbot() {
        // Create a script element
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/tocbot/4.27.4/tocbot.min.js';
        script.onload = function() {
            tocbot.init({
                // Where to render the table of contents.
                tocSelector: '.gh-toc',
                // Where to grab the headings to build the table of contents.
                contentSelector: '.gh-content',
                // Which headings to grab inside of the contentSelector element.
                headingSelector: 'h2, h3',
                // Ensure correct positioning
                hasInnerContainers: true,
            });
        };
        
        document.head.appendChild(script);
    }

    function addTocHTML() {
        
        const aside = document.createElement('aside');
        aside.className = 'gh-sidebar';
        
        const p = document.createElement('p');
        p.textContent = 'Table of contents';
        
        const div = document.createElement('div');
        div.className = 'gh-toc';
        
        aside.appendChild(p);
        aside.appendChild(div);
        
        const section = document.querySelector('.gh-content.article-canvas');
        
        if (section) {
            
            section.insertBefore(aside, section.firstChild);
        }
    }

    function checkViewportAndLoadTocbot() {
        if (window.innerWidth > 1000) {
            addTocHTML();
            loadTocbot();
        }
    }

    document.addEventListener('DOMContentLoaded', checkViewportAndLoadTocbot);

    // Check viewport on resize
    window.addEventListener('resize', function() {
        // Remove existing TOC if viewport width is less than or equal to 1000
        if (window.innerWidth <= 1000) {
            const aside = document.querySelector('.gh-sidebar');
            if (aside) {
                aside.remove();
            }
        }
    });

const scrollTopBtn = document.querySelector('.js-scroll-top');
if (scrollTopBtn) {
  scrollTopBtn.onclick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
}

const offset = 2000;
window.addEventListener(
  'scroll',
  function (event) {
    const scrollPos =
      window.scrollY ||
      window.scrollTop ||
      document.getElementsByTagName('html')[0].scrollTop;
    scrollPos > offset
      ? scrollTopBtn.classList.add('is-active')
      : scrollTopBtn.classList.remove('is-active');
  },
  false
);

function addCopyIcons() {
    // Select all h2 and h3 elements within .gh-content
    const headings = document.querySelectorAll('.gh-content h2, .gh-content h3');

    headings.forEach((heading, index) => {
        // Generate an id if it doesn't exist
        if (!heading.id) {
            // Create a slug from the heading's text content
            const slug = heading.textContent
                .toLowerCase()
                .trim()
                .replace(/[^a-z0-9]+/g, '-') // Replace spaces and non-alphanumerics with '-'
                .replace(/^-|-$/g, ''); // Remove leading/trailing dashes
            heading.id = slug || `heading-${index}`; // Fallback id if slug is empty
        }

        // Create a span element to hold the icon
        const iconSpan = document.createElement('span');
        iconSpan.className = 'copy-icon';

        // Insert your custom icon HTML
        iconSpan.innerHTML = `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.667 18.667h-5.734l.974-5.334h4.76a1.334 1.334 0 0 0 0-2.666h-4.28l.92-5.08A1.335 1.335 0 0 0 22.187 4a1.334 1.334 0 0 0-1.627 1.093l-1 5.574h-5.173l.92-5.08A1.335 1.335 0 0 0 14.187 4a1.334 1.334 0 0 0-1.627 1.093l-1 5.574H5.333a1.333 1.333 0 0 0 0 2.667h5.734l-.974 5.333h-4.76a1.333 1.333 0 0 0 0 2.666h4.28l-.92 5.08A1.333 1.333 0 0 0 9.813 28a1.336 1.336 0 0 0 1.627-1.093l1-5.573h5.173l-.92 5.08A1.335 1.335 0 0 0 17.813 28a1.34 1.34 0 0 0 1.435-.582c.098-.155.164-.33.192-.511l1-5.573h6.227a1.334 1.334 0 0 0 0-2.667m-13.734 0 .974-5.334h5.16l-.974 5.334z"/></svg>`;

        // Wrap heading content in a div for flex display
        const container = document.createElement('div');
        container.className = heading.tagName === 'H2' ? 'H2-container' : 'H3-container';
        
        // Insert the container before the heading and append the heading and iconSpan to it
        heading.parentNode.insertBefore(container, heading);
        container.appendChild(heading);
        container.appendChild(iconSpan);

        // Add event listener to handle the copy action
        iconSpan.addEventListener('click', () => {
            // Create a temporary input element to hold the anchor link
            const tempInput = document.createElement('input');
            document.body.appendChild(tempInput);
            tempInput.value = `${window.location.href.split('#')[0]}#${heading.id}`;
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);

            // Show toast notification
            showToast('Anchor link copied');
        });
    });
}


// Function to show toast notification
function showToast(message) {
    const toast = document.getElementById('toast');
    toast.innerText = message;
    toast.className = 'toast show';
    setTimeout(() => { toast.className = toast.className.replace('show', ''); }, 3000);
}

// Call the function to add copy icons
document.addEventListener('DOMContentLoaded', addCopyIcons);


